export default "__VITE_PUBLIC_ASSET__bb922d2b__"